import React, { FC } from "react";
import { mdiArrowRight } from "@mdi/js";
import { Icon } from "@mdi/react";

import BetMgmCta from "public/logos/mgm-lion-banner.png";
import { BetMgmLogo } from "../BetMgmLogo";
import styles from "./styles.scss";
import { Button } from "../Button";

export const MgmBanner: FC<Props> = ({ ctaText = "START NOW", onCtaClick }) => {
  return (
    <div className="bet-mgm-offer-banner">
      <div className="copy">
        <div className="logo-container">
          <BetMgmLogo textColor="black" height={32} />
        </div>
        <div className="deposit">
          Deposit <strong>$10</strong> and place a bet on <strong>BetMGM</strong>
        </div>
        <div className="free-months">
          <strong>
            Get <span className="alt-span">12 FREE</span>months of<span className="blue-betql">&nbsp;BetQL!</span>
          </strong>
        </div>
      </div>
      <div className="cta-logo">
        <img className="mgm-cta" src={BetMgmCta} />
        <div className="colored-background">
          <Button className="cta" onClick={onCtaClick}>
            <strong className="text">{ctaText}</strong>
            <Icon color="#fff" path={mdiArrowRight} size="20px" />
          </Button>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

interface Props {
  ctaText?: string;
  onCtaClick?: () => void;
}
